export const HPC_BRAND = {
  name: "TEBA HPU - Health & Performance Unit",
  tagline: "Where Health Meets Performance",
  logoSrc: `${process.env.PUBLIC_URL}/images/teba-hpu-logo.png`,
};
